import React, { useContext, useEffect, useMemo } from 'react'
import './index.scss'
import WizardFlow from '@Components/WizardFlow'
import { ICONS } from '@Const/common'
import { StoresContext } from '@App/contexts'
import WizardFlowStep from '@Components/WizardFlow/wizard-flow-step'

const WizardRegisterWorkFlow = () => {
    const { wizardFlowStore } = useContext(StoresContext)

    const flow = useMemo<WizardFlowStep[]>(
        () => [
            {
                stepIndicator: {
                    icon: ICONS.search,
                    label: 'Search',
                },
                forms: [<form key={1}>1. Search Form</form>],
            },
            {
                stepIndicator: {
                    icon: ICONS.workDetails,
                    label: 'Enter Work Details',
                },
                forms: [<form key={2}>2. Work Details Form</form>],
            },
            {
                stepIndicator: {
                    icon: ICONS.writers,
                    label: 'Add Writers',
                },
                forms: [<form key={3}>3. Add Writers</form>],
            },

            {
                stepIndicator: {
                    icon: ICONS.publishers,
                    label: 'Add Publishers & Shares',
                },
                forms: [<form key={4}>4. Add Publishers & Shares</form>],
            },

            {
                stepIndicator: {
                    icon: ICONS.recordings,
                    label: 'Add Recording',
                },
                forms: [<form key={5}>5. Add Recording</form>],
            },
            {
                stepIndicator: {
                    icon: ICONS.workDetails,
                    label: 'Review',
                },
                forms: [<form key={6}>6. Review</form>],
            },
        ],
        []
    )

    useEffect(() => {
        wizardFlowStore.setFlow(flow)
    }, [flow, wizardFlowStore])

    return <WizardFlow heading="Wizard Flow" />
}

export default WizardRegisterWorkFlow
